module.exports = __webpack_public_path__ + "media/images/article/2022_05_b-a32bf3a8dffb5b2ad3bb7aca08f5885e.png";